import React, { useState } from 'react';
import Locales from 'locales';
import { renderCGUContent } from 'helpers';
import { ChevronRight } from 'lucide-react';

const Cgu = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleBlock = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-hajj-muted via-white to-green-50 flex items-start justify-center">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-hajj-primary/5 rounded-full blur-3xl animate-pulse" />
        <div
          className="absolute bottom-20 right-10 w-96 h-96 bg-green-200/20 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}
        />
      </div>

      <div className="relative w-full max-w-3xl animate-scale-in space-y-6 p-[50px]">
        {/* Page Header */}
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 tracking-tight mb-2">{Locales.cgu.title}</h1>
        </div>

        {/* CGU Navigation */}
        <nav className="space-y-4">
          <ol className="space-y-2 divide-y divide-gray-300">
            {Locales.cgu.articles.map((article) => (
              <li key={article.id} className="pt-2">
                <button
                  type="button"
                  onClick={() => toggleBlock(article.id)}
                  className="w-full flex justify-between items-center text-left text-lg font-medium text-gray-900 hover:text-hajj-primary transition-colors py-2"
                >
                  <span>{article.article}</span>
                  <ChevronRight
                    className={`h-5 w-5 text-gray-500 transition-transform duration-300 ${
                      openIndex === article.id ? 'rotate-90' : 'rotate-0'
                    }`}
                  />
                </button>

                {openIndex === article.id && (
                  <section className="mt-2 bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg transition-all duration-300 space-y-4">
                    {renderCGUContent(article.content, `cgu-${article.id}`)}
                  </section>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Cgu;
